import React, { useMemo } from 'react';
import { Row, Col, Tabs } from 'antd';
import { useSelector } from 'react-redux';
import PaymentListFunctional from './payment-list-functional';
import { API_STATUS } from 'constants/app-constants';
// import { CreditCard } from 'lucide-react'; // Optional icon

const GymPaymentsTab = () => {
	const globalRedux = useSelector((state) => state.globalRedux);
	const tableLoading = useMemo(
		() => globalRedux.apiStatus.GET_PAYMENTS === API_STATUS.PENDING,
		[globalRedux.apiStatus]
	);

	const items = [
		{
			key: 'Payments',
			disabled: tableLoading,
			label: (
				<span style={{ display: 'flex', alignItems: 'center' }}>
					{/* <CreditCard size={16} style={{ marginRight: 6 }} /> */}
					Payments
				</span>
			),
			children: <PaymentListFunctional paymentType="payments" />,
		},
	];

	return (
		<Row className="payments-tab-container" style={{ height: '80%' }}>
			<Col span={24} className="container">
				<Tabs defaultActiveKey="Payments" destroyInactiveTabPane items={items} />
			</Col>
		</Row>
	);
};

export default GymPaymentsTab;
